import { type ReactNode, useMemo } from "react";

import type { ReadyCheck } from "../api/hooks/useProjectAgentStatus";
import { useCitedTexts } from "./useReadinessCitations";

// Where a condition comes from, by its basis; the cited ones show their citation.
export const CITED_BASIS: Partial<Record<ReadyCheck["basis"], string>> = {
  client_spec: "the client's specification",
  global_data: "global data",
  project_record: "a project document",
};

// Every met check's proof and every cited source, resolved once for the page, as the
// readiness record's are.
export const useReadyCheckEvidence = (
  checks: ReadyCheck[],
): { cite: (text: string) => ReactNode; modal: ReactNode } =>
  useCitedTexts(
    useMemo(
      () =>
        checks
          .flatMap((c) => [c.evidence, CITED_BASIS[c.basis] ? c.basis_source : ""])
          .filter(Boolean),
      [checks],
    ),
  );
